import http from 'src/api/endpoints';
import { PARENT_URL } from 'src/config/parentURL';
import { ErrorMessageFromApi } from 'src/constants';
import { errorHelper } from 'src/utils';
import { getTypedThunk } from '../utils';
import URIs from 'src/config/urls';
import {
  transformTimelineData,
  transformTimelineDataByHours,
  transformTimelineDataByProjects,
} from './helpers';
const { TIMELINE } = URIs;
const { PARAMS } = TIMELINE;
const { BY_HOURS_VIEW, BY_PROJECTS_VIEW } = PARAMS;

const timelineThunk = getTypedThunk<
  undefined,
  {
    start_date: string;
    end_date: string;
    byHours?: boolean;
    byProjects?: boolean;
  }
>();

export const getTimeline = timelineThunk(
  'timeline',
  async (
    { start_date, end_date, byHours, byProjects },
    { rejectWithValue }
  ) => {
    try {
      const response = await http.getTimeline(
        PARENT_URL.TIMELINE_BASE,
        `?${(byHours && BY_HOURS_VIEW) ?? ''}${
          (byProjects && BY_PROJECTS_VIEW) ?? ''
        }&start_date=${start_date}&end_date=${end_date}`
      );

      if (response.message === 'Success!') {
        if (byHours) {
          return transformTimelineDataByHours(response.data);
        }
        if (byProjects) {
          return transformTimelineDataByProjects(response.data);
        }
        return transformTimelineData(response.data);

        return response.data;
      }
      return rejectWithValue(errorHelper(ErrorMessageFromApi));
    } catch (error) {
      return rejectWithValue(errorHelper(error));
    }
  }
);
